import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import PopupWrapper from "../Common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import paramRender from "@mnjsplatform/components/lib/common/ParamRenderUniversal";
import RadioGroupJson from "../Common/RadioGroupJson";

const customFieldExMap = {
    RadioGroupJson: (props) => <RadioGroupJson {...props} />
};

class CreateRef extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem.initialize({}, {
                newItem: true,
                withParams: true,
                refresh: false
            }));
        } catch (e) {
            console.error(e);
        }
    };

    save = async () => {
        await this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItemParams));
        if (!this.props.dataItem.isError) {
            if (this.props.onCreated) {
                const row = this.props.dataItem.getRow(0);
                this.props.onCreated(row);
            }
            if (this.props.onClose) {
                this.props.onClose(false);
            }
        }
    }

    renderButtons = () => {
        return (
            <div className="modal-footer text-right">
                <button type="button" className="btn btn-regular -goahead"
                        onClick={this.save}>{i18next.t("Create_Ref_1")}
                </button>
                <button type="button" className="btn btn-regular -default" data-dismiss="modal"
                        onClick={this.props.onClose}>{i18next.t("Cancel_Noun")}</button>
            </div>
        );
    };

    render() {
        return (
            <PopupWrapper popupVisible={true} title={i18next.t("Create_Ref_2")} maxWidthBody="800px"
                          instructionId="REQUEST_CREATE"
                          onClose={this.props.onClose} renderButtons={this.renderButtons}>
                <ComplexParam dataItem={this.props.dataItemParams} autoApplyParams={false}
                              showApplyButton={false} showSearchBar={false}
                              customFieldExMap={customFieldExMap}
                              renderParams={paramRender}
                />
            </PopupWrapper>
        );
    }
}

CreateRef.propTypes = {
    dispatch: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItemParams: PropTypes.object,
    onCreated: PropTypes.func,
    onClose: PropTypes.func
};

CreateRef.defaultProps = {
    onCreated: () => {
    },
    onClose: () => {
    }
};

function mapStateToProps(state, ownProps) {
    return {
        dataItem: state.referencesState.EDocInfoOut_NewFromPO,
        dataItemParams: state.referencesState.EDocInfoOut_NewFromPO_Params
    }
}

export default connect(mapStateToProps)(CreateRef);